var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "job-listing" }, [
    _c(
      "div",
      {
        class: [
          "job-listing--items",
          { "job-listing--items-loading": _vm.loadingJobs }
        ]
      },
      [
        _c(
          "div",
          { staticClass: "job-listing--item" },
          [
            _vm.withHead
              ? _c("ListItemHead", {
                  attrs: { job: _vm.job },
                  on: {
                    save: function($event) {
                      return _vm.$emit("save")
                    },
                    closeMessages: function($event) {
                      return _vm.$emit("jobChanged", _vm.job)
                    },
                    closeAppointments: function($event) {
                      return _vm.$emit("jobChanged", _vm.job)
                    },
                    publish: function($event) {
                      return _vm.$emit("publish")
                    },
                    unpublish: function($event) {
                      return _vm.$emit("unpublish")
                    },
                    loadFavorites: function($event) {
                      _vm.onlyFavorites = true
                    }
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isPublished || _vm.internal || _vm.forceListing
              ? _c("ResultsListing", {
                  attrs: {
                    job: _vm.job,
                    "only-favorites": _vm.onlyFavorites,
                    "only-excluded": _vm.onlyExcluded
                  },
                  on: {
                    messagesClosed: function($event) {
                      return _vm.$emit("messagesClosed")
                    }
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }